import classnames from 'classnames';
import * as React from 'react';

import { Day as DayModel } from '../../../../schemas/Day';
import { useTheme } from '../../../../../theme';
import { RendererFunctionsContext } from '../../../Datepicker';

export interface Props {
	day: DayModel;
	dayRender?: (date: Date) => React.ReactNode;
	onSelect: (date: Date) => void;
	onHover?: (date: Date) => void;
}

export const Day: React.FunctionComponent<Props> = (props: Props) => {
	const theme = useTheme('Datepicker').DayStyles;

	return (
		<div
			data-test-id="calendar-day"
			data-day={props.day.date.getDate()}
			data-date={[
				props.day.date.getFullYear(),
				String(props.day.date.getMonth() + 1).padStart(2, '0'),
				String(props.day.date.getDate()).padStart(2, '0')
			].join('-')}
			data-available={props.day.isAvailable ? 'true' : 'false'}
			data-selected={props.day.isSelected && !props.day.fromOtherMonth ? 'true' : 'false'}
			className={classnames(theme.day, props.day.customClass, {
				[theme.day_fromOtherMonth]: props.day.fromOtherMonth,
				[theme.day_selected]: props.day.isSelected && !props.day.fromOtherMonth,
				[theme.day_startPeriod]: props.day.isStartPeriod,
				[theme.day_inPeriod]: props.day.inPeriod,
				[theme.day_endPeriod]: props.day.isEndPeriod,
				[theme.day_notAvailable]: !props.day.isAvailable,
				[theme.day_weekend]: props.day.isWeekend,
				[theme.day_today]: props.day.isToday,
				[theme.day_highlighted]: props.day.customClass,
				[theme.day_startHover]: props.day.isStartHover,
				[theme.day_endHover]: props.day.isEndHover
			})}
			onMouseOver={() => {
				if (props.day.isAvailable && props.onHover) {
					props.onHover(props.day.date);
				}
			}}
			onMouseOut={() => {
				if (props.day.isAvailable && props.onHover) {
					props.onHover(null);
				}
			}}
			onClick={() => {
				props.day.isAvailable ? props.onSelect(props.day.date) : null;
			}}
		>
			<RendererFunctionsContext.Consumer>
				{data => data.dayRenderer(props.day.date, theme.day__inside)}
			</RendererFunctionsContext.Consumer>
		</div>
	);
};
